export const getWorkOrderFlowEnabled = (state) => {
  return state?.companySettings?.workOrderEnabled ?? false;
};
